import { apiFetch as webApiFetch } from '../../api/client';

/** RequestInit used by the TMA layer also supports a local timeout hint. */
type TimedRequestInit = RequestInit & { _timeoutMs?: number };

/**
 * Web transport for the shared platform UI.
 *
 * Authentication is provided by the existing first-party cookie and Bearer
 * fallback in apps/web/src/api/client.ts. Keeping this adapter inside the
 * copied TMA-shaped tree lets every mature screen reuse its original API
 * module without sending Telegram Mini App initData from a desktop browser.
 */
export async function apiFetch<T>(path: string, options?: TimedRequestInit): Promise<T> {
  const timeoutMs = options?._timeoutMs ?? 30_000;
  const controller = new AbortController();
  const callerSignal = options?.signal;
  const abortFromCaller = () => controller.abort(callerSignal?.reason);

  if (callerSignal?.aborted) abortFromCaller();
  else callerSignal?.addEventListener('abort', abortFromCaller, { once: true });

  const timer = window.setTimeout(() => controller.abort(new Error('Превышено время ожидания сервера')), timeoutMs);
  const { _timeoutMs: _timeout, signal: _signal, ...request } = options ?? {};

  try {
    return await webApiFetch<T>(path, { ...request, signal: controller.signal });
  } finally {
    window.clearTimeout(timer);
    callerSignal?.removeEventListener('abort', abortFromCaller);
  }
}
